import _ from "lodash";
import { colors, responsiveFontSizes } from "@mui/material";
import { enUS, zhCN } from "@mui/material/locale";
import { THEMES } from "src/constants";
import { softShadows, strongShadows } from "./shadows";
import typography from "./typography";
import { createTheme as createMuiTheme, adaptV4Theme } from "@mui/material/styles";

const baseOptions = {
    direction: "ltr",
    typography,
    components: {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 3,
                    overflow: "hidden",
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 32,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(0,0,0,0.075)",
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    padding: "5px 0",
                },
            },
        },
        // MuiDialog: {
        //   styleOverrides: {
        //     paper: {
        //       backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)) !important'
        //     }
        //   }
        // },
        // MuiMenu: {
        //   styleOverrides: {
        //     paper: {
        //       backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)) !important'
        //     }
        //   }
        // },
        MuiLink: {
            defaultProps: {
                underline: "hover",
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    background: `#282C34`,
                },
            },
        },
    },
};

const themesOptions = [
    {
        name: THEMES.LIGHT,
        components: {
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        "&::placeholder": {
                            opacity: 1,
                            color: colors.blueGrey[600],
                        },
                    },
                },
            },
        },
        palette: {
            mode: "light",
            action: {
                active: colors.blueGrey[600],
            },
            background: {
                default: colors.common.white,
                dark: "#f4f6f8",
                paper: colors.common.white,
            },
            primary: {
                main: colors.indigo[600],
            },
            secondary: {
                main: "#5850EC",
            },
            text: {
                primary: colors.blueGrey[900],
                secondary: colors.blueGrey[600],
            },
        },
        shadows: softShadows,
    },
    {
        name: THEMES.ONE_DARK,
        palette: {
            mode: "dark",
            action: {
                active: "rgba(255, 255, 255, 0.54)",
                hover: "rgba(255, 255, 255, 0.04)",
                selected: "rgba(255, 255, 255, 0.08)",
                disabled: "rgba(255, 255, 255, 0.26)",
                disabledBackground: "rgba(255, 255, 255, 0.12)",
                focus: "rgba(255, 255, 255, 0.12)",
            },
            background: {
                default: "#282C34",
                dark: "#1c2025",
                paper: "#282C34",
            },
            primary: {
                main: "#00E67E",
            },
            secondary: {
                main: "#00E67E",
            },
            text: {
                primary: "#e6e5e8",
                secondary: "#adb0bb",
            },
        },
        shadows: strongShadows,
    },
    {
        name: THEMES.UNICORN,
        palette: {
            mode: "dark",
            action: {
                active: "rgba(255, 255, 255, 0.54)",
                hover: "rgba(255, 255, 255, 0.04)",
                selected: "rgba(255, 255, 255, 0.08)",
                disabled: "rgba(255, 255, 255, 0.26)",
                disabledBackground: "rgba(255, 255, 255, 0.12)",
                focus: "rgba(255, 255, 255, 0.12)",
            },
            background: {
                default: "#2a2d3d",
                dark: "#222431",
                paper: "#2a2d3d",
            },
            primary: {
                main: "#a67dff",
            },
            secondary: {
                main: "#a67dff",
            },
            text: {
                primary: "#f6f5f8",
                secondary: "#9699a4",
            },
        },
        shadows: strongShadows,
    },
];

const languageOptions = languageCode => {
    switch (languageCode) {
        case "en-US":
            return enUS;

        case "zh-CN":
            return zhCN;

        default:
            return enUS;
    }
};

export const createTheme = (config = {}) => {
    let themeOptions = themesOptions.find(theme => theme.name === config.theme);

    if (!themeOptions) {
        console.warn(new Error(`The theme ${config.theme} is not valid`));
        [themeOptions] = themesOptions;
    }

    let languageOption = languageOptions(
        localStorage.getItem("language") ? localStorage.getItem("language") : config.language
    );

    let theme = createMuiTheme(
        _.merge({}, baseOptions, themeOptions, { direction: config.direction }, languageOption)
    );

    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }

    return theme;
};
